export default {
  merchantUser: state => state.merchant.merchantUser,
  merchantInfo: state => state.merchant.merchantInfo,
  merchantId: state => state.merchant.merchantInfo.id,
  eventId: state => state.event.eventId,
  eventInfo: state => state.event.eventInfo,
  token: state => state.merchant.token,
  appInfo: state => state.app.appInfo
}



// WEBPACK FOOTER //
// ./src/store/getters.js